import type { NewAsset } from 'owa-timestream-asset-sdk-types';
import { DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { createTaskFolder } from 'owa-timestream-asset-sdk-tasks';
import { TASK_TYPE } from '../constants';
import type { TaskViewPayload } from '../schema';

export default async function createNewTaskAsset(
    pageX: number,
    pageY: number
): Promise<NewAsset<TaskViewPayload> | null> {
    await createTaskFolder();
    return {
        type: TASK_TYPE,
        width: DEFAULT_MIN_ASSET_WIDTH,
        payload: {
            taskId: '',
        },
    };
}
